import React, { useEffect, useRef, useState } from 'react';
import CallAPI from '../utility/functions/getData';
import CryptoJS from 'crypto-js';
import { useDispatch, useSelector } from 'react-redux';
import { setSpinnerLoading } from '../utility/Redux/modal';
import { useNavigate, useSearchParams } from 'react-router-dom';
import ViewBillImage from '../utility/component/viewBillImage';
import { CallAPIPromise } from './menu/dashboard/biiling/modal/comman';

import {
  selectViewBillInvoiceId,
  setViewBillInvoiceId,
} from '../utility/Redux/tableOrder';
import { setCompanyAddress, setPrefix } from '../utility/Redux/profile';
import logo from '../utility/images/WGLOGO.png';
const InvoiceBill = () => {
  const [billStatus, setBillStatus] = useState(true);
  const [orderList, setOrderList] = useState([]);
  const componentRef = useRef(null);
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [companyData, setCompanyData] = useState({
    code: '',
    company_email: '',
    company_name: '',
    company_mobile: '',
    company_website: '',
    group_name: null,
    address: '',
    city: '',
    state: '',
  });

  const [searchPeram] = useSearchParams(window.location.search);
  const prefix = searchPeram.get('prefix');
  const billInvoice = useSelector(selectViewBillInvoiceId);
  const navigate = useNavigate();
  const bill = searchPeram.get('bill');
  const companyEmail = searchPeram.get('companyEmail');
  useEffect(() => {
    if (bill) {
      setLoading(true);
      const secretPass = process.env.REACT_APP_AUTH_SECRET_KEY;

      // const hmac = CryptoJS.HmacSHA256(message, secret);
      const hmac = CryptoJS.HmacSHA256(companyEmail, secretPass);
      // Convert the HMAC to a string and encode it using Base64
      const hmacString = hmac.toString(CryptoJS.enc.Base64);
      dispatch(setPrefix(prefix));
      dispatch(setViewBillInvoiceId(bill));
      CallAPIPromise(
        `/api/users/companyInfo`,
        {
          company_email: companyEmail,
        },
        hmacString,
        dispatch
      )
        .then((response) => {
          if (response.data.response[0]) {
            const userDetail = response.data.response[0];
            console.log(userDetail);
            dispatch(
              setCompanyAddress({
                address: userDetail.address,
                city: userDetail.city,
                state: userDetail.state,
                mobile: userDetail.company_mobile,
                email: userDetail.company_email,
                companyName: userDetail.company_name,
                companyWebsite: userDetail.company_website,
      message_send_through:userDetail.message_send_through,
      rfid_module: userDetail.rfid_module,

              })
            );
          }
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [bill]);
  return (
    <div className=" relative w-screen h-screen  flex flex-col  bg-[#dce2ef]  items-center">
      <div className=" w-full  p-6 md:p-10 bg-gradient-to-br from-pink-300 via-purple-300 to-yellow-200 text-gray-900 shadow-md mb-6 flex flex-col md:flex-row items-center justify-between gap-1">
        <div className="flex items-start gap-2">
          {/* Icon Circle */}
          <img src={logo} alt="RetailX Logo" className="h-[60px] w-[60px] " />
          {/* Text Content */}
          <div>
            <div className="t:text-[24px] text-[20px] font-semibold">
              Start selling online.
            </div>
            <p className="text-sm text-gray-800 mt-1">
              Take your business online with RetailxApp. Get your online store
              in easy steps.
            </p>
          </div>
        </div>
        {/* CTA */}
        <button
          onClick={() => {
            navigate('/auth/signup');
          }}
          className="bg-black  text-white px-5 py-2 rounded-md font-medium hover:bg-gray-800 transition"
        >
          Get Started
        </button>
      </div>
      <div className="shadow-lg mb-[65px] w-[360px] bg-white rounded-[12px] overflow-y-auto">
        <div className="h-[22px] w-[22px] flex  justify-self-center -mt-3 bg-[#dce2ef] rounded-full "></div>
        {billInvoice && !loading && (
          <ViewBillImage setBillStatus={setBillStatus} ref={componentRef} />
        )}
      </div>
      <div
        onClick={() => {
          navigate('/');
        }}
        className=" absolute bottom-0  font-semibold text-center  w-full p-2 md:p-2 bg-gradient-to-br from-pink-300 via-purple-300 to-yellow-200 text-gray-900 shadow-md flex flex-col  items-center justify-between gap-6"
      >
        Powerd by www.routebilling.com
      </div>
    </div>
  );
};

export default InvoiceBill;
